(ns nl.mediquest.ui.util
  (:require
   [clojure.set :refer [intersection]]
   [clojure.string :as string]
   [integrant.core :as ig]))

(defn optional-ref
  [k default]
  (try (ig/init-key k {})
       (ig/ref k)
       (catch js/Error _
         default)))

(defn matches-key?
  [coll k]
  (seq (intersection
        (set coll)
        (if (coll? k) (set k) #{k}))))

(defn component-key->anchor-id
  [component-k]
  (if (coll? component-k)
    (->> component-k (map name) (string/join "-"))
    (name component-k)))
